export default {"src":"/_next/static/media/chatBubbleWithQuestionMark_64.95f22a57.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};